module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-142587183-1","head":false,"anonymize":true,"respectDNT":true,"exclude":["/admin"],"sampleRate":5,"siteSpeedSampleRate":10},
    }]
